import loadable from '@loadable/component';
import Loading from '../components/Loader';

const PayModal = loadable(
  () => import(/* webpackChunkName: "pay-modal" */ '../containers/PayModal'),
  { fallback: Loading }
);

export default PayModal;
